var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEncircledDisclaimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.69,
    height: 14.691,
    viewBox: "0 0 14.69 14.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_221520",
    "data-name": "Path 221520",
    d: "M9.345,5.673a.737.737,0,0,1,.735.735V9.345a.735.735,0,0,1-1.469,0V6.407A.737.737,0,0,1,9.345,5.673ZM9.338,2A7.345,7.345,0,1,0,16.69,9.345,7.342,7.342,0,0,0,9.338,2Zm.007,13.221a5.876,5.876,0,1,1,5.876-5.876A5.875,5.875,0,0,1,9.345,15.221Zm.735-2.2H8.611V11.549H10.08Z",
    transform: "translate(-2 -2)",
    fill: "#f35e5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncircledDisclaimer);
export default __webpack_public_path__ + "static/media/encircledDisclaimer.7f50a850d5c98343e89dfed2c9389699.svg";
export { ForwardRef as ReactComponent };